export const imageData = [
    {
      "id": 1,
      "href": require("../assets/zines/1_sontag_1.png"),
      "src": require("../assets/zines/1_sontag_1.png"),
      "alt": "Susan Sontag Part 1"
    },
    {
      "id": 2,
      "href": require("../assets/zines/1_sontag_2.png"),
      "src": require("../assets/zines/1_sontag_2.png"),
      "alt": "Susan Sontag Part 2"
    },
    {
      "id": 3,
      "href": require("../assets/zines/2_stein_1.jpg"),
      "src": require("../assets/zines/2_stein_1.jpg"),
      "alt": "Gertrude Stein Part 1"
    },
    {
      "id": 4,
      "href": require("../assets/zines/2_stein_2.jpg"),
      "src": require("../assets/zines/2_stein_2.jpg"),
      "alt": "Gertrude Stein Part 2"
    },
    {
      "id": 5,
      "href": require("../assets/zines/3_lorde_1.png"),
      "src": require("../assets/zines/3_lorde_1.png"),
      "alt": "Audre Lorde Part 1"
    },
    {
      "id": 6,
      "href": require("../assets/zines/3_lorde_2.png"),
      "src": require("../assets/zines/3_lorde_2.png"),
      "alt": "Audre Lorde Part 2"
    },
    {
      "id": 7,
      "href": require("../assets/zines/4_nin_1.png"),
      "src": require("../assets/zines/4_nin_1.png"),
      "alt": "Anais Nin Part 1"
    },
    {
      "id": 8,
      "href": require("../assets/zines/4_nin_2.png"),
      "src": require("../assets/zines/4_nin_2.png"),
      "alt": "Anais Nin Part 2"
    },
    {
      "id": 9,
      "href": require("../assets/zines/5_acker_1.jpg"),
      "src": require("../assets/zines/5_acker_1.jpg"),
      "alt": "Kathy Acker Part 1"
    },
    {
      "id": 10,
      "href": require("../assets/zines/5_acker_2.jpg"),
      "src": require("../assets/zines/5_acker_2.jpg"),
      "alt": "Kathy Acker Part 2"
    },
    {
      "id": 11,
      "href": require("../assets/zines/6_dumaurier_1.jpg"),
      "src": require("../assets/zines/6_dumaurier_1.jpg"),
      "alt": "Daphne du Maurier Part 1"
    },
    {
      "id": 12,
      "href": require("../assets/zines/6_dumaurier_2.jpg"),
      "src": require("../assets/zines/6_dumaurier_2.jpg"),
      "alt": "Daphne du Maurier Part 2"
    },
    {
      "id": 13,
      "href": require("../assets/zines/7_mccullers_1.png"),
      "src": require("../assets/zines/7_mccullers_1.png"),
      "alt": "Carson McCullers Part 1"
    },
    {
      "id": 14,
      "href": require("../assets/zines/7_mccullers_2.png"),
      "src": require("../assets/zines/7_mccullers_2.png"),
      "alt": "Carson McCullers Part 2"
    },
    {
      "id": 15,
      "href": require("../assets/zines/8_sappho_1.jpg"),
      "src": require("../assets/zines/8_sappho_1.jpg"),
      "alt": "Sappho Part 1"
    },
    {
      "id": 16,
      "href": require("../assets/zines/8_sappho_2.jpg"),
      "src": require("../assets/zines/8_sappho_2.jpg"),
      "alt": "Sappho Part 2"
    },
    {
      "id": 17,
      "href": require("../assets/zines/10_solanas_1.JPG"),
      "src": require("../assets/zines/10_solanas_1.JPG"),
      "alt": "Valerie Solanas Part 1"
    },
    {
      "id": 18,
      "href": require("../assets/zines/10_solanas_2.JPG"),
      "src": require("../assets/zines/10_solanas_2.JPG"),
      "alt": "Valerie Solanas Part 2"
    },
    {
      "id": 19,
      "href": require("../assets/zines/11_woolf_1.png"),
      "src": require("../assets/zines/11_woolf_1.png"),
      "alt": "Virginia Woolf Part 1"
    },
    {
      "id": 20,
      "href": require("../assets/zines/11_woolf_2.png"),
      "src": require("../assets/zines/11_woolf_2.png"),
      "alt": "Virginia Woolf Part 2"
    },
    {
      "id": 21,
      "href": require("../assets/zines/12_dickinson_1.png"),
      "src": require("../assets/zines/12_dickinson_1.png"),
      "alt": "Emily Dickinson Part 1"
    },
    {
      "id": 22,
      "href": require("../assets/zines/12_dickinson_2.png"),
      "src": require("../assets/zines/12_dickinson_2.png"),
      "alt": "Emily Dickinson Part 2"
    },
    {
      "id": 23,
      "href": require("../assets/zines/13_hall_1.png"),
      "src": require("../assets/zines/13_hall_1.png"),
      "alt": "Radclyffe Hall Part 1"
    },
    {
      "id": 24,
      "href": require("../assets/zines/13_hall_2.png"),
      "src": require("../assets/zines/13_hall_2.png"),
      "alt": "Radclyffe Hall Part 2"
    },
    {
      "id": 25,
      "href": require("../assets/zines/14_bechdel_1.png"),
      "src": require("../assets/zines/14_bechdel_1.png"),
      "alt": "Alison Bechdel Part 1"
    },
    {
      "id": 26,
      "href": require("../assets/zines/14_bechdel_2.png"),
      "src": require("../assets/zines/14_bechdel_2.png"),
      "alt": "Alison Bechdel Part 2"
    },
    {
      "id": 27,
      "href": require("../assets/zines/15_dawson_1.png"),
      "src": require("../assets/zines/15_dawson_1.png"),
      "alt": "Rachel Dawson Part 1"
    },
    {
      "id": 28,
      "href": require("../assets/zines/15_dawson_2.png"),
      "src": require("../assets/zines/15_dawson_2.png"),
      "alt": "Rachel Dawson Part 2"
    },
    {
      "id": 29,
      "href": require("../assets/zines/16_highsmith_1.png"),
      "src": require("../assets/zines/16_highsmith_1.png"),
      "alt": "Patricia Highsmith Part 1"
    },
    {
      "id": 30,
      "href": require("../assets/zines/16_highsmith_2.png"),
      "src": require("../assets/zines/16_highsmith_2.png"),
      "alt": "Patricia Highsmith Part 2"
    },
    {
      "id": 31,
      "href": require("../assets/zines/17_unreal_1.jpeg"),
      "src": require("../assets/zines/17_unreal_1.jpeg"),
      "alt": "Unreal Sex Part 1"
    },
    {
      "id": 32,
      "href": require("../assets/zines/17_unreal_2.jpeg"),
      "src": require("../assets/zines/17_unreal_2.jpeg"),
      "alt": "Unreal Sex Part 2"
    },
    {
      "id": 33,
      "href": require("../assets/zines/20_wharton_1.png"),
      "src": require("../assets/zines/20_wharton_1.png"),
      "alt": "Edith Wharton Part 1"
    },
    {
      "id": 34,
      "href": require("../assets/zines/20_wharton_2.png"),
      "src": require("../assets/zines/20_wharton_2.png"),
      "alt": "Edith Wharton Part 2"
    },
    {
      "id": 35,
      "href": require("../assets/zines/21_winterson_1.jpeg"),
      "src": require("../assets/zines/21_winterson_1.jpeg"),
      "alt": "Jeanette Winterson Part 1"
    },
    {
      "id": 36,
      "href": require("../assets/zines/21_winterson_2.jpeg"),
      "src": require("../assets/zines/21_winterson_2.jpeg"),
      "alt": "Jeanette Winterson Part 2"
    },
  ]
  